import React from "react";
import "./index.css";

export default function NoResults() {
  return <h2 className="text-center">No Results Found</h2>;
}
